import { SvgIconDefinition } from '@am/icons-common-types';
const width = 128;
const height = 128;
const path = `M89.391,43.223c2.691,0,4.911,2.222,4.911,4.911c0,2.702-2.21,4.911-4.911,4.911H37.329c-1.083,0-1.965-0.883-1.965-1.966v-5.894c0-1.081,0.883-1.963,1.965-1.963H89.391z M13.754,88.405C6.181,88.405,0,82.228,0,74.652V7.859C0,3.538,3.539,0,7.86,0h13.753c4.321,0,7.857,3.533,7.857,7.859v45.186c0,3.246,2.648,5.893,5.894,5.893H92.34c1.075,0,1.963,0.888,1.963,1.966c0,15.145-12.354,27.501-27.504,27.501v19.65h4.911c2.691,0,4.911,2.22,4.911,4.911c0,2.702-2.209,4.911-4.911,4.911H8.842c-2.691,0-4.911-2.22-4.911-4.911c0-2.702,2.21-4.911,4.911-4.911h4.911V88.405z`;

export const aciPrivateBathroom: SvgIconDefinition = {
  iconName: 'private-bathroom',
  iconData: [height, width, path],
};
